var React = require('react');

function BackendDropdownMenuCustomerAccounts (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M12 11.020v-0.207c1.446-0.553 2.5-2.275 2.5-4.313 0-2.485-1.567-4.5-3.5-4.5s-3.5 2.015-3.5 4.5c0 2.038 1.054 3.76 2.5 4.313v0.207c-3.392 0.139-6 0.972-6 1.98v2h14v-2c0-1.008-2.608-1.841-6-1.98z","key":0}),React.createElement("path",{"fill":"#000000","d":"M18 7.009v-0.079c1.141-0.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5s-2.5 1.567-2.5 3.5c0 1.693 0.859 3.106 2 3.43v0.079c-0.497 0.018-0.97 0.064-1.404 0.131-0.098 1.066-0.439 2.051-0.965 2.859h7.369v-1.5c0-0.772-1.75-1.408-4-1.491z","key":1}),React.createElement("path",{"fill":"#000000","d":"M6.404 7.141c-0.435-0.068-0.907-0.113-1.404-0.131v-0.079c1.141-0.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5s-2.5 1.567-2.5 3.5c0 1.693 0.859 3.106 2 3.43v0.079c-2.25 0.083-4 0.719-4 1.491v1.5h7.369c-0.526-0.809-0.867-1.794-0.965-2.859z","key":2})]);
}

BackendDropdownMenuCustomerAccounts.displayName = "BackendDropdownMenuCustomerAccounts";

BackendDropdownMenuCustomerAccounts.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 22 16"};

module.exports = BackendDropdownMenuCustomerAccounts;

BackendDropdownMenuCustomerAccounts.default = BackendDropdownMenuCustomerAccounts;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-customer-accounts.svg
// module id = 993
// module chunks = 0